"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("../../button");
var _Toolbox = require("./Toolbox.style");
var _helpers = require("../helpers");
var _ToolboxFunctionsItems = _interopRequireDefault(require("./ToolboxFunctionsItems"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var buttonsId = 'formula-toolbox';
var leftParanthesisLabel = '(';
var rightParanthesisLabel = ')';
var Toolbox = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Toolbox, _React$PureComponent);
  var _super = _createSuper(Toolbox);
  function Toolbox() {
    _classCallCheck(this, Toolbox);
    return _super.apply(this, arguments);
  }
  _createClass(Toolbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        actions = _this$props.actions,
        functionsEnabled = _this$props.functionsEnabled,
        focusedPath = _this$props.focusedPath,
        labels = _this$props.labels,
        paranthesesEnabled = _this$props.paranthesesEnabled,
        disabled = _this$props.disabled,
        betweenEnabled = _this$props.betweenEnabled,
        className = _this$props.className,
        noFunctions = _this$props.noFunctions,
        noGroups = _this$props.noGroups,
        noBetween = _this$props.noBetween,
        clearFocus = _this$props.clearFocus,
        keysPath = _this$props.keysPath,
        thresholdIndex = _this$props.thresholdIndex,
        thresholdRowIndex = _this$props.thresholdRowIndex;
      var reachedMaxNestingPath = (0, _helpers.hasReachedMaxNestingDept)(focusedPath);
      return /*#__PURE__*/_react["default"].createElement(_Toolbox.StyledToolbox, {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_Toolbox.StyledToolboxWrapper, {
        hasNone: noGroups && noFunctions && noBetween
      }, !noGroups && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_button.Button, {
        className: "toolbox-formula-button toolbox-left-parenthesis",
        disabled: !paranthesesEnabled || disabled,
        onMouseDown: function onMouseDown(ev) {
          ev.stopPropagation();
          actions.addLeftBracket(keysPath);
          clearFocus();
        },
        type: "naked"
      }, leftParanthesisLabel), /*#__PURE__*/_react["default"].createElement(_button.Button, {
        className: "toolbox-formula-button toolbox-right-parenthesis",
        disabled: !paranthesesEnabled || disabled,
        onMouseDown: function onMouseDown(ev) {
          ev.stopPropagation();
          actions.addRightBracket(keysPath);
          clearFocus();
        },
        type: "naked"
      }, rightParanthesisLabel)), !noFunctions && /*#__PURE__*/_react["default"].createElement(_ToolboxFunctionsItems["default"], {
        labels: labels,
        buttonsId: buttonsId,
        functionsEnabled: functionsEnabled,
        reachedMaxNestingPath: reachedMaxNestingPath,
        disabled: disabled,
        keysPath: keysPath,
        actions: actions,
        clearFocus: clearFocus
      }), !noBetween && /*#__PURE__*/_react["default"].createElement(_button.Button, {
        className: "toolbox-formula-button toolbox-formula-between",
        key: "".concat(buttonsId, "-between"),
        disabled: !betweenEnabled || disabled,
        onMouseDown: function onMouseDown(ev) {
          ev.stopPropagation();
          actions.addFunctionBetween(thresholdIndex, thresholdRowIndex);
          clearFocus();
        },
        type: "naked"
      }, labels.FORMULA_BETWEEN_FUNCTION_LABEL)));
    }
  }]);
  return Toolbox;
}(_react["default"].PureComponent);
Toolbox.defaultProps = {
  noBetween: false,
  noGroups: false,
  noFunctions: false,
  disabled: false,
  focusedPath: [],
  functionsEnabled: false,
  betweenEnabled: false,
  className: 'Formula-toolbox',
  thresholdIndex: 0,
  thresholdRowIndex: 0
};
Toolbox.propTypes = {
  disabled: _propTypes["default"].bool,
  clearFocus: _propTypes["default"].func.isRequired,
  noBetween: _propTypes["default"].bool,
  noGroups: _propTypes["default"].bool,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  focusedPath: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  functionsEnabled: _propTypes["default"].bool,
  betweenEnabled: _propTypes["default"].bool,
  actions: _propTypes["default"].shape({
    addLeftBracket: _propTypes["default"].func.isRequired,
    addRightBracket: _propTypes["default"].func.isRequired,
    addFunctionMin: _propTypes["default"].func.isRequired,
    addFunctionMax: _propTypes["default"].func.isRequired,
    addFunctionBetween: _propTypes["default"].func.isRequired,
    addFunctionRound: _propTypes["default"].func.isRequired,
    addFunctionRoundUp: _propTypes["default"].func.isRequired,
    addFunctionRoundDown: _propTypes["default"].func.isRequired
  }).isRequired,
  paranthesesEnabled: _propTypes["default"].bool.isRequired,
  className: _propTypes["default"].string,
  noFunctions: _propTypes["default"].bool,
  thresholdIndex: _propTypes["default"].number,
  thresholdRowIndex: _propTypes["default"].number,
  keysPath: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])), _propTypes["default"].number]).isRequired
};
Toolbox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Toolbox",
  "props": {
    "noBetween": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "noGroups": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "noFunctions": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "focusedPath": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "number"
          }]
        }
      },
      "required": false
    },
    "functionsEnabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "betweenEnabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "'Formula-toolbox'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "thresholdIndex": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "thresholdRowIndex": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "clearFocus": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "actions": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "addLeftBracket": {
            "name": "func",
            "required": true
          },
          "addRightBracket": {
            "name": "func",
            "required": true
          },
          "addFunctionMin": {
            "name": "func",
            "required": true
          },
          "addFunctionMax": {
            "name": "func",
            "required": true
          },
          "addFunctionBetween": {
            "name": "func",
            "required": true
          },
          "addFunctionRound": {
            "name": "func",
            "required": true
          },
          "addFunctionRoundUp": {
            "name": "func",
            "required": true
          },
          "addFunctionRoundDown": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    },
    "paranthesesEnabled": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "keysPath": {
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "union",
            "value": [{
              "name": "string"
            }, {
              "name": "number"
            }]
          }
        }, {
          "name": "number"
        }]
      },
      "required": true
    }
  }
};
var _default = Toolbox;
exports["default"] = _default;